<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="各项配置" name="config">
        <p class="title">交流概况</p>
        <el-form
          label-position="right"
          label-width="120px"
          :model="formData"
          :rules="rules"
          ref="refForm"
        >
          <el-form-item label="对外交流次数" prop="foreign">
            <el-input
              type="Number"
              class="numInput"
              v-model.number="formData.foreign"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="对内交流次数" prop="internal">
            <el-input
              type="Number"
              class="numInput"
              v-model.number="formData.internal"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动次数" prop="activity">
            <el-input
              type="Number"
              v-model.number="formData.activity"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
        </el-form>
        <!-- 活动类型 -->
        <p class="title">
          活动类型
          <el-button
            style="margin-left: 20px"
            type="text"
            @click="addActivityType"
            >添加活动类型</el-button
          >
        </p>
        <div class="formBox">
          <el-form
            v-for="(activityItem, activityIndex) in formData.activity_type"
            :ref="`refForm${activityIndex}`"
            :key="activityIndex"
            :model="activityItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item
              label-width="120px"
              label="类型名称："
              prop="activity_name"
            >
              <el-input
                v-model="activityItem.activity_name"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="120px" label="数量" prop="nums">
              <!-- <el-input
              type="number" min="0" class="numInput"
                v-model="activityItem.nums"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              ></el-input> -->
              <el-input
                style="width: 207px; float: left"
                v-model.number="activityItem.nums"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
              <i
                v-if="activityIndex != 0"
                @click="delActivityType(activityIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
        </div>

        <!-- 园区行业类型统计 -->
        <p class="title">
          园区行业类型统计
          <el-button style="margin-left: 20px" type="text" @click="addParkTypes"
            >添加活动类型</el-button
          >
        </p>
        <div class="formBox">
          <el-form
            v-for="(parkItem, parkIndex) in formData.park_types"
            :ref="`parkForm${parkIndex}`"
            :key="'park' + parkIndex"
            :model="parkItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item
              label-width="120px"
              label="类型名称："
              prop="type_name"
              class="err_position"
            >
              <el-input
                v-model="parkItem.type_name"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
            <el-form-item
              label-width="120px"
              label="数量"
              prop="nums"
              class="err_position"
            >
              <!-- <el-input
              type="number" min="0" class="numInput"
                v-model="parkItem.nums"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              ></el-input> -->
              <el-input
                style="width: 207px; float: left"
                v-model.number="parkItem.nums"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
              <i
                v-if="parkIndex != 0"
                @click="delParkTypes(parkIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
        </div>
        <!-- 自营农业商品种类概括 -->
        <p class="title">
          自营农业商品种类概括
          <el-button style="margin-left: 20px" type="text" @click="addProduct"
            >添加自营农业商品种类</el-button
          >
        </p>
        <div class="formBox">
          <el-form
            v-for="(productItem, productIndex) in formData.product_types"
            :ref="`productForm${productIndex}`"
            :key="'product' + productIndex"
            :model="productItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item
              label-width="120px"
              label="种类名称："
              prop="product_name"
            >
              <el-input
                v-model="productItem.product_name"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="120px" label="数量" prop="nums">
              <!-- <el-input
              type="number" min="0" class="numInput"
                v-model="productItem.nums"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              ></el-input> -->
              <el-input
                style="width: 207px; float: left"
                v-model.number="productItem.nums"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
              <i
                v-if="productIndex != 0"
                @click="delProduct(productIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
        </div>
        <!-- 自营餐厅就餐活跃度 -->
        <p class="title">自营餐厅就餐活跃度</p>
        <div class="formBox">
          <el-form
            v-for="(activeItem, activeIndex) in formData.restaurants_active"
            :ref="`activeForm${activeIndex}`"
            :key="'active' + activeIndex"
            :model="activeItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item label-width="120px" label="时间：" prop="time">
              <el-input
                disabled
                v-model="activeItem.time"
                style="width: 207px; float: left"
                placeholder="请输入内容"
                ><template slot="append">时</template></el-input
              >
            </el-form-item>
            <el-form-item
              label-width="120px"
              label="数量"
              prop="nums"
              class="err_position"
            >
              <!-- <el-input
              type="number" min="0" class="numInput"
                v-model="activeItem.nums"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              ></el-input> -->
              <el-input
                style="width: 207px; float: left"
                v-model.number="activeItem.nums"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 自营装修服务次数 -->
        <p class="title">自营装修服务</p>
        <div class="formBox">
          <el-form
            v-for="(
              servicesItem, servicesIndex
            ) in formData.decoration_services"
            :ref="`servicesForm${servicesIndex}`"
            :key="'services' + servicesIndex"
            :model="servicesItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item label-width="120px" label="时间：" prop="time">
              <el-input
                disabled
                v-model="servicesItem.time"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              >
                <template slot="append">月</template></el-input
              >
            </el-form-item>
            <el-form-item label-width="120px" label="数量" prop="nums">
              <!-- <el-input
              type="number" min="0" class="numInput"
                v-model="servicesItem.nums"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              ></el-input> -->
              <el-input
                style="width: 207px; float: left"
                v-model.number="servicesItem.nums"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <el-form>
          <el-form-item>
            <el-button type="primary" @click="infoSubmit()">保存</el-button>
            <el-button @click="getInfo()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- <el-tab-pane label="活动展示" name="activity">
        <el-button size="small" type="primary" @click="activityAdd()"
          >添加</el-button
        >
        <el-table
          :data="activityData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="id" label="ID" width="100"> </el-table-column>
          <el-table-column label="活动性质" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.nature }}</span>
            </template>
          </el-table-column>
          <el-table-column label="活动地点" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.location }}</span>
            </template>
          </el-table-column>
          <el-table-column label="活动图片" min-width="200">
            <template slot-scope="scope">
              <el-image
                style="width: 170px; height: 100px; margin: 0 5px 5px 0"
                :src="imageOss + scope.row.thumb.split(',')[0]"
                fit="contain"
                :preview-src-list="$pathDispose(scope.row.thumb.split(','))"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="活动时间" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="activitySee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="activityEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="activityDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="activityPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="activitySize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="activityTotal"
          >
          </el-pagination>
        </div>
      </el-tab-pane> -->
      <el-tab-pane label="满意度调查" name="satisfy">
        <el-button size="small" type="primary" @click="satisfyAdd()"
          >添加</el-button
        >
        <el-table
          :data="satisfyData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="id" label="ID" width="100"> </el-table-column>
          <el-table-column label="日期类型" width="150">
            <template slot-scope="scope">
              <span>{{
                scope.row.is_seven_day_yz == 1 ? "是近七天" : "是近一月"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="十分满意次数" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.ten_satisfied_yz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="满意次数" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.satisfied_yz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="一般次数" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.general_satisfied_yz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="待改进次数" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.wait_improve_satisfied_yz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="不满意次数" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.no_satisfied_yz }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="satisfySee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="satisfyEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="satisfyDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <!-- 活动展示 -->
    <el-dialog
      :title="activityTitle"
      :visible.sync="activityFormVisible"
      width="800px"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="80px"
        :model="activityForm"
        ref="activityForm"
        :rules="activityRules"
      >
        <el-form-item label="活动性质" prop="nature">
          <el-input
            v-model="activityForm.nature"
            auto-complete="off"
            placeholder="请输入活动性质"
            :disabled="activityCz == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动地点" prop="location">
          <el-input
            :disabled="activityCz == 'see'"
            v-model="activityForm.location"
            auto-complete="off"
            placeholder="请输入活动地点"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间" prop="time">
          <el-date-picker
            :disabled="activityCz == 'see'"
            v-model="activityForm.time"
            type="datetime"
            value-format="timestamp"
            placeholder="请选择活动时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动图片" prop="thumb">
          <el-upload
            ref="upload"
            name="file[]"
            :data="{ type: 'image' }"
            :action="ossUpload"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :disabled="activityCz == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="activityCz == 'see' ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="文章内容" prop="content">
          <el-input
            :disabled="activityCz == 'see'"
            v-model="activityForm.content"
            auto-complete="off"
            type="textarea"
            placeholder="请输入文章内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          v-if="activityCz == 'add'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="activitySubmit('activityForm')"
          >添加</el-button
        >
        <el-button
          v-if="activityCz == 'edit'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="activityTjEdit('activityForm')"
          >提交编辑</el-button
        >
      </div>
    </el-dialog>
    <!-- 满意度添加 -->
    <el-dialog
      :title="satisfyTitle"
      :visible.sync="satisfyFormVisible"
      width="800px"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form label-width="150px" :model="satisfyForm" ref="satisfyForm">
        <el-form-item
          label="日期类型"
          :rules="{
            required: true,
            message: '请选择日期类型',
            trigger: 'change',
          }"
        >
          <el-radio-group v-model="satisfyForm.is_seven_day_yz">
            <el-radio :label="1">是近七天</el-radio>
            <el-radio :label="0">是近一月</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="十分满意次数_业主" prop="ten_satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.ten_satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入十分满意次数_业主"
          ></el-input>
        </el-form-item>
        <el-form-item label="满意次数_业主" prop="satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入满意次数_业主"
          ></el-input>
        </el-form-item>
        <el-form-item label="一般次数_业主" prop="general_satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.general_satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入一般次数_业主"
          ></el-input>
        </el-form-item>
        <el-form-item label="待改进次数_业主" prop="wait_improve_satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.wait_improve_satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入待改进次数_业主"
          ></el-input>
        </el-form-item>
        <el-form-item label="不满意次数_业主" prop="no_satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.no_satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入不满意次数_业主"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="satisfyFormVisible = false">取消</el-button>
        <el-button
          v-if="satisfyCz == 'add'"
          size="small"
          type="primary"
          :loading="loading"
          
          @click="satisfySubmit('satisfyForm')"
          >添加</el-button
        >
        <el-button
          v-if="satisfyCz == 'edit'"
          size="small"
          type="primary"
          :loading="loading"
          @click="satisfyTjEdit('satisfyForm')"
          >提交编辑</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  yzYYActivityAdd,
  yzYYActivityEdit,
  yzYYActivityDel,
  yzYYActivityList,
  yzYYActivityDetail,
  yzYYConfigEdit,
  yzYYConfigDetail,
  yzYYSatisfyList,
  yzYYSatisfyDetail,
  yzYYSatisfyDel,
  yzYYSatisfyEdit,
  yzYYSatisfyAdd,
} from "@/api/yunzhou";
import { delImage } from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  components: {},
  computed: {
    ...mapGetters(["imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ossUpload: this.$store.state.ossUpload,
      loading: false, //是显示加载
      activeName: "config",
      configsForm: {
        ruleList: [
          {
            ruleString: "",
          },
        ],
        deal_area: "",
        company_nums: "",
        business_nums: "",
        deal_nums: "",
      },
      formData: {
        foreign: "21",
        internal: "2",
        activity: "1",
        activity_type: [
          {
            activity_name: "55",
            nums: "2",
          },
        ],
        park_types: [
          {
            type_name: "24",
            nums: "45",
          },
        ],
        product_types: [
          {
            product_name: "875",
            nums: "46",
          },
        ],
        decoration_services: [
          {
            time: "1",
            time_type: "M",
            nums: "54",
          },
          {
            time: "2",
            time_type: "M",
            nums: "57",
          },
          {
            time: "3",
            time_type: "M",
            nums: "8",
          },
          {
            time: "4",
            time_type: "M",
            nums: "87",
          },
          {
            time: "5",
            time_type: "M",
            nums: "57",
          },
          {
            time: "6",
            time_type: "M",
            nums: "57",
          },
          {
            time: "7",
            time_type: "M",
            nums: "57",
          },
          {
            time: "8",
            time_type: "M",
            nums: "57",
          },
          {
            time: "9",
            time_type: "M",
            nums: "57",
          },
          {
            time: "10",
            time_type: "M",
            nums: "57",
          },
          {
            time: "11",
            time_type: "M",
            nums: "75",
          },
          {
            time: "12",
            time_type: "M",
            nums: "57",
          },
        ],
        restaurants_active: [
          {
            time: "1",
            time_type: "H",
            nums: "",
          },
          {
            time: "2",
            time_type: "H",
            nums: "",
          },
          {
            time: "3",
            time_type: "H",
            nums: "",
          },
          {
            time: "4",
            time_type: "H",
            nums: "",
          },
          {
            time: "5",
            time_type: "H",
            nums: "",
          },
          {
            time: "6",
            time_type: "H",
            nums: "",
          },
          {
            time: "7",
            time_type: "H",
            nums: "",
          },
          {
            time: "8",
            time_type: "H",
            nums: "",
          },
          {
            time: "9",
            time_type: "H",
            nums: "",
          },
          {
            time: "10",
            time_type: "H",
            nums: "",
          },
          {
            time: "11",
            time_type: "H",
            nums: "",
          },
          {
            time: "12",
            time_type: "H",
            nums: "",
          },
          {
            time: "13",
            time_type: "H",
            nums: "",
          },
          {
            time: "14",
            time_type: "H",
            nums: "",
          },
          {
            time: "15",
            time_type: "H",
            nums: "",
          },
          {
            time: "16",
            time_type: "H",
            nums: "",
          },
          {
            time: "17",
            time_type: "H",
            nums: "",
          },
          {
            time: "18",
            time_type: "H",
            nums: "",
          },
          {
            time: "19",
            time_type: "H",
            nums: "",
          },
          {
            time: "20",
            time_type: "H",
            nums: "",
          },
          {
            time: "21",
            time_type: "H",
            nums: "",
          },
          {
            time: "22",
            time_type: "H",
            nums: "",
          },
          {
            time: "23",
            time_type: "H",
            nums: "",
          },
          {
            time: "24",
            time_type: "H",
            nums: "",
          },
        ],
      },
      rules: {
        activity_name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        nums: [{ required: true, message: "请输入数量", trigger: "blur" }],
        type_name: [
          {
            required: true,
            message: "请输入园区行业类型名称",
            trigger: "blur",
          },
        ],
        product_name: [
          {
            required: true,
            message: "请输入自营农业商品种类名称",
            trigger: "blur",
          },
        ],
        foreign: [
          { required: true, message: "请输入对外交流次数", trigger: "blur" },
        ],
        internal: [
          { required: true, message: "请输入对内交流次数", trigger: "blur" },
        ],
        activity: [
          { required: true, message: "请输入活动次数", trigger: "blur" },
        ],
      },
      activityData: [],
      activityTitle: "添加",
      activityCz: "add",
      activityFormVisible: false,
      activityForm: {},
      activityRules: {
        nature: [
          { required: true, message: "请输入活动性质", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入文章内容", trigger: "blur" },
        ],
        location: [
          { required: true, message: "请输入活动地点", trigger: "blur" },
        ],
        time: [{ required: true, message: "请输入活动时间", trigger: "blur" }],
        thumb: [
          { required: true, message: "请选择活动图片", trigger: "change" },
        ],
      },
      activityPage: 1,
      activityTotal: 80,
      activitySize: 15,
      fileList: [],

      satisfyData: [],
      satisfyTitle: "添加",
      satisfyCz: "add",
      satisfyFormVisible: false,
      satisfyForm: {},
      satisfyRules: {
        nature: [
          { required: true, message: "请输入活动性质", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入文章内容", trigger: "blur" },
        ],
        location: [
          { required: true, message: "请输入活动地点", trigger: "blur" },
        ],
        time: [{ required: true, message: "请输入活动时间", trigger: "blur" }],
        thumb: [
          { required: true, message: "请选择活动图片", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // 重点项目宣传-详情
    satisfyInfo(id) {
      yzYYSatisfyDetail({ id: id }).then((res) => {
        this.satisfyForm = {
          id: res.data.id,
          ten_satisfied_yz: res.data.ten_satisfied_yz,
          satisfied_yz: res.data.satisfied_yz,
          general_satisfied_yz: res.data.general_satisfied_yz,
          wait_improve_satisfied_yz: res.data.wait_improve_satisfied_yz,
          no_satisfied_yz: res.data.no_satisfied_yz,
          is_seven_day_yz: res.data.is_seven_day_yz,
        };
      });
    },
    // 表格编辑操作
    satisfyEdit(val) {
      this.satisfyTitle = "编辑";
      this.satisfyCz = "edit";
      this.satisfyInfo(val.id);
      this.satisfyFormVisible = true;
    },
    // 表格查看操作
    satisfySee(val) {
      this.satisfyTitle = "查看";
      this.satisfyCz = "see";
      this.satisfyInfo(val.id);
      this.satisfyFormVisible = true;
    },

    // 满意度调查-删除
    satisfyDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          yzYYSatisfyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getSatisfyList();
          });
        })
        .catch(() => {});
    },
    // 满意度调查-新增
    satisfySubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          yzYYSatisfyAdd(that.satisfyForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getSatisfyList();
              that.satisfyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 满意度调查-编辑
    satisfyTjEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          yzYYSatisfyEdit(that.satisfyForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getSatisfyList();
              that.satisfyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 添加满意度调查
    satisfyAdd() {
      this.satisfyFormVisible = true;
      this.satisfyTitle = "添加";
      this.satisfyCz = "add";
      this.satisfyForm = {
        ten_satisfied_yz: "",
        satisfied_yz: "",
        general_satisfied_yz: "",
        wait_improve_satisfied_yz: "",
        no_satisfied_yz: "",
        is_seven_day_yz: 1,
      };
    },
    // 获取满意度调查
    getSatisfyList() {
      yzYYSatisfyList().then((res) => {
        this.satisfyData = res.data;
      });
    },
    // 删除图片
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    // 活动图片
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.activityForm.thumb = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 活动图片删除
    handleRemove(file, fileList) {
      if (file.response.data.url) {
        this.fileList.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.activityForm.thumb = list.join(",");
      // this.fileList = [];
      // this.activityForm.thumb = "";
    },
    // 活动图片上传限制
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传人脸图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 获取重点项目宣传
    getActivityList() {
      let data = {
        page: this.activityPage,
        page_size: this.activitySize,
      };
      yzYYActivityList(data).then((res) => {
        this.activityTotal = res.data.total;
        this.activityData = res.data.data;
      });
    },
    // 重点项目分页
    handleSizeChange(val) {
      this.activitySize = val;
      this.getActivityList();
    },
    // 重点项目分页
    handleCurrentChange(val) {
      this.activityPage = val;
      this.getActivityList();
    },

    // 重点项目宣传-新增
    activitySubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.activityForm.activity_time = that.activityForm.time / 1000;
          yzYYActivityAdd(that.activityForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getActivityList();
              that.activityFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重点项目宣传-编辑
    activityTjEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.activityForm.activity_time = that.activityForm.time / 1000;
          yzYYActivityEdit(that.activityForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getActivityList();
              that.activityFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重点项目宣传-删除
    activityDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          yzYYActivityDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getActivityList();
          });
        })
        .catch(() => {});
    },
    // 重点项目宣传-详情
    activityInfo(id) {
      yzYYActivityDetail({ id: id }).then((res) => {
        this.activityForm = {
          id: res.data.id,
          thumb: res.data.thumb,
          time: res.data.activity_time * 1000,
          nature: res.data.nature,
          content: res.data.content,
          location: res.data.location,
        };
        this.fileList = [];
        if (res.data.thumb) {
          let list = res.data.thumb.split(",");
          this.fileList = list.map((item) => {
            return {
              name: +new Date(),
              url: this.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
      });
    },
    // 添加重点项目宣传
    activityAdd() {
      this.activityFormVisible = true;
      this.activityTitle = "添加";
      this.activityCz = "add";
      this.activityForm = {
        thumb: "",
        time: "",
        nature: "",
        content: "",
        location: "",
      };
    },
    // 表格编辑操作
    activityEdit(val) {
      this.activityTitle = "编辑";
      this.activityCz = "edit";
      this.activityInfo(val.id);
      this.activityFormVisible = true;
    },
    // 表格查看操作
    activitySee(val) {
      this.activityTitle = "查看";
      this.activityCz = "see";
      this.activityInfo(val.id);
      this.activityFormVisible = true;
    },
    // 获取基础信息
    getInfo() {
      yzYYConfigDetail().then((res) => {
        if (res.data.communication_overview) {
          this.formData.foreign = JSON.parse(
            res.data.communication_overview
          ).foreign;
          this.formData.internal = JSON.parse(
            res.data.communication_overview
          ).internal;
          this.formData.activity = JSON.parse(
            res.data.communication_overview
          ).activity;
        }
        if (res.data.activity_type) {
          this.formData.activity_type = JSON.parse(res.data.activity_type);
        }
        if (res.data.park_types) {
          this.formData.park_types = JSON.parse(res.data.park_types);
        }
        if (res.data.product_types) {
          this.formData.product_types = JSON.parse(res.data.product_types);
        }
        if (res.data.restaurants_active) {
          this.formData.restaurants_active = JSON.parse(
            res.data.restaurants_active
          );
        }
        if (res.data.decoration_services) {
          this.formData.decoration_services = JSON.parse(
            res.data.decoration_services
          );
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.activityFormVisible = false;
    },
    infoSubmit() {
      var that = this;
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //非数组部分的表单
        this.validateForm("refForm"),
        // 数组部分的表单，用map返回验证函数的调用
        // 活动类型
        ...this.formData.activity_type.map((item, index) =>
          this.validateForm(`refForm${index}`)
        ),
        // 园区行业类型统计
        ...this.formData.park_types.map((item, index) =>
          this.validateForm(`parkForm${index}`)
        ),
        // 自营农业商品种类概括
        ...this.formData.product_types.map((item, index) =>
          this.validateForm(`productForm${index}`)
        ),
        // 自营餐厅就餐活跃度
        ...this.formData.restaurants_active.map((item, index) =>
          this.validateForm(`activeForm${index}`)
        ),
        // 自营装修服务次数
        ...this.formData.decoration_services.map((item, index) =>
          this.validateForm(`servicesForm${index}`)
        ),
        this.$nextTick(() => {
          that.elFormErrorScrollIntoView();
        }),
      ]).then((res) => {
        let overview = {
          foreign: this.formData.foreign,
          internal: this.formData.internal,
          activity: this.formData.activity,
        };
        let data = {
          communication_overview: JSON.stringify(overview),
          activity_type: JSON.stringify(this.formData.activity_type),
          park_types: JSON.stringify(this.formData.park_types),
          product_types: JSON.stringify(this.formData.product_types),
          restaurants_active: JSON.stringify(this.formData.restaurants_active),
          decoration_services: JSON.stringify(
            this.formData.decoration_services
          ),
        };
        yzYYConfigEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getInfo();
          }
        });
        if (res) {
          // 全部表单验证通过
        }
      });
    },
    validateForm(refs) {
      //获取到form表单的dom，如果是对象直接拿到，如果是数组，就拿第一个
      //elementui对循环的form包装成了数组
      let valiForm = this.$refs?.[refs].validate
        ? this.$refs?.[refs]
        : this.$refs?.[refs][0];
      return new Promise((resolve, reject) => {
        //在Promise里进行验证，如果通过就resolve()
        valiForm.validate((res) => {
          if (res) resolve();
          else reject();
        });
      });
    },
    // 添加活动类型
    addActivityType() {
      this.formData.activity_type.push({
        activity_name: "",
        nums: "",
      });
    },
    // 删除活动类型
    delActivityType(index) {
      this.formData.activity_type.splice(index, 1);
    },
    // 添加园区行业类型统计
    addParkTypes() {
      this.formData.park_types.push({
        type_name: "",
        nums: "",
      });
    },
    // 删除园区行业类型统计
    delParkTypes(index) {
      this.formData.park_types.splice(index, 1);
    },
    // 添加自营农业商品种类概括
    addProduct() {
      this.formData.product_types.push({
        product_name: "",
        nums: "",
      });
    },
    // 删除自营农业商品种类概括
    delProduct(index) {
      this.formData.product_types.splice(index, 1);
    },
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.getInfo();
      } else if (tab.index == 1) {
        // this.getActivityList();
        this.getSatisfyList();
      }
      //  else if (tab.index == 2) {
      //   this.getSatisfyList();
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
.title {
  font-size: 16px;
  font-weight: 600;
}
.formBox {
  width: 100%;
  max-height: 300px;
  overflow: auto;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
